// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import creportEntity from './entities/creport.json';
import creportMenu from '../pages/creport/menu.json';
import creportFullForm from '../pages/creport/forms/full.json';
import creportContextForm from '../pages/creport/forms/context.json';
import creportMiniForm from '../pages/creport/forms/mini.json';
import creportLookupForm from '../pages/creport/forms/lookup.json';
import creportTableView from '../pages/creport/views/table.json';
import creportStagesView from '../pages/creport/views/stages.json';
import creportBacklogView from '../pages/creport/views/backlog.json';
import creportSplitView from '../pages/creport/views/split.json';
import creportCardsView from '../pages/creport/views/cards.json';
import creportCalendarView from '../pages/creport/views/calendar.json';
import creportDashboardView from '../pages/creport/views/dashboard.json';

/** Тип запису «Звіт» зі сторінками пакета: меню, форми та подання з pages/creport/. */
export const creportDefinition: IRecordTypeDefinition = {
  ...creportEntity,
  views: assembleViewSet({
      table: creportTableView,
      stages: creportStagesView,
      backlog: creportBacklogView,
      split: creportSplitView,
      cards: creportCardsView,
      calendar: creportCalendarView,
      dashboard: creportDashboardView,
  }),
  form: creportFullForm,
  forms: { full: creportFullForm, context: creportContextForm, mini: creportMiniForm, lookup: creportLookupForm },
  menu: creportMenu,
} as IRecordTypeDefinition;
